enum GameStatus {
    Ready = 'ready',
    Started = 'started',
    Completed = 'completed'
}

export default GameStatus